import { FC, useState } from 'react';

import {
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';

import { profileReportsColumns } from '@/components/molecules/Tables/ProfileReportsRow/constants';
import { ProfileReportsRow } from '@/components/molecules/Tables/ProfileReportsRow/ProfileReportsRow.tsx';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/molecules/Tables/Table/Table.tsx';
import { DirectReportsData } from '@/types/account-settings';

type DirectReportsTabProps = {
  reports: DirectReportsData[];
};

export const DirectReportsTab: FC<DirectReportsTabProps> = ({ reports }) => {
  const [sortingState, setSortingState] = useState<SortingState>([]);

  const table = useReactTable({
    data: reports,
    columns: profileReportsColumns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    state: {
      sorting: sortingState,
    },
    onSortingChange: setSortingState,
  });

  return (
    <Table>
      <TableHeader>
        {table.getHeaderGroups().map(headerGroup => (
          <TableRow key={headerGroup.id}>
            {headerGroup.headers.map(header => (
              <TableHead
                key={header.id}
                onClick={header.column.getToggleSortingHandler()}
                className="min-w-[260px]"
              >
                {flexRender(header.column.columnDef.header, header.getContext())}
              </TableHead>
            ))}
          </TableRow>
        ))}
      </TableHeader>
      <TableBody>
        {table.getSortedRowModel().rows.map(row => (
          <ProfileReportsRow key={row.id} rowData={row.original} />
        ))}
      </TableBody>
    </Table>
  );
};
